/* CAFFREY Cortona: page behaviour. Upgrade build, Claude Code (launch agent BUILDER, WORKFLOW-P), 2026-10-08.
   The buy box itself runs on the kit (cf-kit.js <cf-kit-buy>: colour pills -> hidden [name=id] + change event, price,
   button state, ?variant=; <cf-kit-sticky>). This file only adds:
     1. "Crema shown" on the hero picture whenever a colour other than the pictured one is chosen;
     2. the root-cause arrow draws once when the drawing scrolls into view (drawn already without JS / reduced motion);
     3. "Pair it with" quick adds: nothing is preselected; Add to cart with nothing chosen shows the card's prompt and
        focuses the select instead of sending a request (capture phase: runs before Dawn's <product-form> handler).
   Safe to include more than once. Theme-editor section reloads re-run the setup. */
(function () {
  if (window.CfCortona) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupHero(root) {
    var hero = root.querySelector ? (root.matches && root.matches('[data-ctn-hero]') ? root : root.querySelector('[data-ctn-hero]')) : null;
    if (!hero || hero._ctn) return;
    hero._ctn = true;
    var pictured = hero.getAttribute('data-pictured') || 'Crema';
    var shown = hero.querySelector('[data-ctn-shown]');
    hero.addEventListener('cf-kit:variant', function (e) {
      var v = e.detail && e.detail.variant;
      if (!shown || !v || !v.o) return;
      shown.hidden = v.o.indexOf(pictured) !== -1;
    });
  }

  function setupDraw(root) {
    var figs = root.querySelectorAll ? root.querySelectorAll('[data-ctn-draw]') : [];
    Array.prototype.forEach.call(figs, function (fig) {
      if (fig._ctn || reduced || !('IntersectionObserver' in window)) return;
      fig._ctn = true;
      var box = fig.getBoundingClientRect();
      if (box.top < window.innerHeight * 0.85 && box.bottom > 0) return; // already on screen: leave it drawn
      fig.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { fig.classList.add('is-in'); io.disconnect(); }
        });
      }, { threshold: 0.5 });
      io.observe(fig);
    });
  }

  function message(form, on) {
    var msg = form.querySelector('[data-ctn-choose-msg]');
    var select = form.querySelector('select[data-ctn-choose]');
    if (msg) msg.hidden = !on;
    if (select) select.setAttribute('aria-invalid', on ? 'true' : 'false');
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('.ctn-routine')) return;
    var select = form.querySelector('select[data-ctn-choose]');
    if (!select || select.value) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    message(form, true);
    select.focus();
  }, true);
  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('select[data-ctn-choose]')) return;
    if (select.value && select.form) message(select.form, false);
  });

  function setup(root) { setupHero(root); setupDraw(root); }
  function start() { setup(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });

  window.CfCortona = { setup: setup };
})();
